"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoredDocumentType = void 0;
exports.instanceOfStoredDocumentType = instanceOfStoredDocumentType;
exports.StoredDocumentTypeFromJSON = StoredDocumentTypeFromJSON;
exports.StoredDocumentTypeFromJSONTyped = StoredDocumentTypeFromJSONTyped;
exports.StoredDocumentTypeToJSON = StoredDocumentTypeToJSON;
exports.StoredDocumentTypeToJSONTyped = StoredDocumentTypeToJSONTyped;
/**
 *
 * @export
 */
exports.StoredDocumentType = {
    AdminChatAttachment: 'ADMIN_CHAT_ATTACHMENT',
    Certification: 'CERTIFICATION',
    DhsClearanceLetter: 'DHS_CLEARANCE_LETTER',
    DhsRegistryCheckResult: 'DHS_REGISTRY_CHECK_RESULT',
    Vaccination: 'VACCINATION'
};
function instanceOfStoredDocumentType(value) {
    for (const key in exports.StoredDocumentType) {
        if (Object.prototype.hasOwnProperty.call(exports.StoredDocumentType, key)) {
            if (exports.StoredDocumentType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function StoredDocumentTypeFromJSON(json) {
    return StoredDocumentTypeFromJSONTyped(json, false);
}
function StoredDocumentTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function StoredDocumentTypeToJSON(value) {
    return value;
}
function StoredDocumentTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=StoredDocumentType.js.map